export const Zhengshu = () => {
  return (
    <div className="flex justify-center bg-[linear-gradient(180deg,#FFFFFF_0%,#F8F6FF_34.13%,#E8F3FF_66.35%,#FFFFFF_100%)] mt-[160px]">
      <div className="w-[1920px] flex py-[112px] gap-[36px]">
        <div className="flex-1">
          <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-bold text-[45px] text-[#333333]">
            专业资质，值得信赖
          </div>
          <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-regular text-[22px] text-[#777777] mt-[30px] max-w-[610px]">
            光年无界具备完整的全球网络加速服务合规证书，确保我们在企业出海服务中的合规和信誉，让您的业务更安心
          </div>
          <div className="flex items-center gap-[12px] mt-[45px]">
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_18031_7799)">
                <path
                  d="M0 12C0 5.37269 5.37269 0 12 0C18.6273 0 24 5.37269 24 12C24 18.6273 18.6273 24 12 24C5.37269 24 0 18.6273 0 12ZM9.82759 16.5617C9.97832 16.7171 10.184 16.8073 10.4004 16.8128C10.6168 16.8184 10.8269 16.7389 10.9854 16.5914L18.8491 9.28055C19.0087 9.13083 19.1024 8.92402 19.1099 8.70535C19.1174 8.48668 19.038 8.27394 18.889 8.11367C18.7401 7.9534 18.5337 7.85863 18.3151 7.8501C18.0964 7.84157 17.8833 7.91996 17.7223 8.06814L10.4772 14.8543L7.07586 11.347C7.00045 11.268 6.91012 11.2046 6.81009 11.1606C6.71007 11.1167 6.60232 11.0929 6.49308 11.0908C6.38383 11.0887 6.27525 11.1082 6.17359 11.1483C6.07193 11.1883 5.97921 11.2481 5.90078 11.3242C5.82235 11.4003 5.75977 11.4912 5.71663 11.5915C5.6735 11.6919 5.65068 11.7999 5.64947 11.9091C5.64827 12.0184 5.66872 12.1268 5.70964 12.2281C5.75055 12.3295 5.81113 12.4217 5.88786 12.4994L9.828 16.5617H9.82759Z"
                  fill="#74B9FF"
                />
              </g>
              <defs>
                <clipPath id="clip0_18031_7799">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-regular text-[22px] text-[#003366]">
              增值电信业务经营许可证
            </div>
          </div>
          <div className="flex items-center gap-[12px] mt-[30px]">
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_18031_7799)">
                <path
                  d="M0 12C0 5.37269 5.37269 0 12 0C18.6273 0 24 5.37269 24 12C24 18.6273 18.6273 24 12 24C5.37269 24 0 18.6273 0 12ZM9.82759 16.5617C9.97832 16.7171 10.184 16.8073 10.4004 16.8128C10.6168 16.8184 10.8269 16.7389 10.9854 16.5914L18.8491 9.28055C19.0087 9.13083 19.1024 8.92402 19.1099 8.70535C19.1174 8.48668 19.038 8.27394 18.889 8.11367C18.7401 7.9534 18.5337 7.85863 18.3151 7.8501C18.0964 7.84157 17.8833 7.91996 17.7223 8.06814L10.4772 14.8543L7.07586 11.347C7.00045 11.268 6.91012 11.2046 6.81009 11.1606C6.71007 11.1167 6.60232 11.0929 6.49308 11.0908C6.38383 11.0887 6.27525 11.1082 6.17359 11.1483C6.07193 11.1883 5.97921 11.2481 5.90078 11.3242C5.82235 11.4003 5.75977 11.4912 5.71663 11.5915C5.6735 11.6919 5.65068 11.7999 5.64947 11.9091C5.64827 12.0184 5.66872 12.1268 5.70964 12.2281C5.75055 12.3295 5.81113 12.4217 5.88786 12.4994L9.828 16.5617H9.82759Z"
                  fill="#74B9FF"
                />
              </g>
              <defs>
                <clipPath id="clip0_18031_7799">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-regular text-[22px] text-[#003366]">
              增值电信业务经营许可证
            </div>
          </div>
        </div>
        <img
          src="/imgs/about/4.png"
          className="w-[430px] min-w-[330px] h-[530px]"
        />
        <img
          src="/imgs/about/5.png"
          className="w-[430px] min-w-[330px] h-[530px]"
        />
      </div>
    </div>
  );
};
